//#region : Imports

import { Component, OnInit, Input } from "@angular/core";

import { GlobalsService } from "../globals.service";

import { StatsComponent } from "../components/stats/stats.component";

import * as moment from "moment";

import { Router } from "@angular/router";
import { AccessGroup, AccessLevel } from "../settings";
import { AnalyticsComponent } from "../components/analytics/analytics.component";
import { AsideComponent } from "../aside/aside.component";
import { ThrowStmt } from "@angular/compiler";

//#endregion

declare var $: any;
declare var jQuery: any;
declare var intlTelInputUtils: any;

var csv = require("csvtojson");
var generator = require("shortid");

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  //Tables
  private peopleTable: any;
  private groupTable: any;
  private deviceTable: any;
  private linkedUserOrgTable: any;
  private accountsTable: any;
  private auditTable: any;
  private userOnboardingTable: any;
  private orgunitsList: any;
  private adminHeader: string = "Open Admin";
  private linkedOrgs: any = [];
  private selecteduser: any = {
    name: "",
    role: "",
    personid: "",
    group: "All",
  };
  private selectedClass: any;
  private user_phoneInput: any;
  private user_phone_disp: string = "";

  private selectedGroup: any = {
    name: "",
    description: "",
    orgid: "",
    reference: "",
    classid: "",
    collector: "",
  };
  private selectedDevice: any = {
    name: "",
    group: "",
    orgid: "",
    classid: "",
    snr: "",
    model: "",
  };
  private isDisabled = true;
  private pass1 = "";
  private pass2 = "";
  private copied = false;
  private deviceData: any;
  private auditAccid: string = "";
  private jsonData: any;
  private jsonTitle: string = "";
  public static instance: HeaderComponent;
  private flavoursUrl: any = "";
  private showFlavourSelector: boolean = false;
  private selectedFlavour = this.globals.buildSettings.flavourOptions[0];
  private flavours = this.globals.buildSettings.flavourOptions;
  private allowUsers: boolean = false;
  private searchSnr = "";
  private anon: boolean = false;
  public decommissionType: "decommission" | "transfer" = "decommission";

  public transferDevice = {
    keepDevice: false,
    keepAccount: false,
    toAccount: undefined,
    oldSnr: undefined,
    newSnr: undefined,
    transferSpecifics: true,
    transferRaws: true,
    transferAggregates: true,
    transferIncidents: true,
    validated: false,
  };

  constructor(private globals: GlobalsService, private router: Router) {
    HeaderComponent.instance = this;

    this.flavoursUrl = this.globals.getUrl("https://www.accitrack.co.za");
  }

  ngOnInit() {
    //Set variable to load table in background
    this.auditAccid = this.globals.entityAccid;
    this.allowUsers =
      this.globals.agentDefaultState == "ANONYMOUS_ACTIVE" ? true : false;
    this.createPersonsTable();
    this.createGroupTable();
    this.createAccountsTable();
    this.createAuditTable();
    this.createUserOnboardingTable();
    this.createPersonOrgunitsTable();

    this.globals.orgunitList(
      (r: any) => {
        //Success

        this.orgunitsList = r.data;
        this.createDeviceTable();
      },
      () => {
        //Failure
      }
    );
  }

  ngAfterViewInit() {
    //Catch toggle password visibility clicks
    $(".toggle-password").click(function () {
      $(this).toggleClass("fa-eye fa-eye-slash");
      var input = $($(this).attr("toggle"));
      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    });

    $(".toggle-password-again").click(function () {
      $(this).toggleClass("fa-eye fa-eye-slash");
      var input = $($(this).attr("toggle"));
      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    });

    let fileSelector = document.getElementById("import-device-file");

    fileSelector.addEventListener("change", (event: any) => {
      //Get the file
      let file = event.target.files[0];

      //File valid?
      if (file) {
        //Get a reader
        let reader = new FileReader();

        reader.onload = (e: any) => {
          let content = e.target.result;

          if (this.globals.buildSettings.appFlavour == "flowcheck") {
            csv({
              noheader: false,
              headers: [
                "snr",
                "site",
                "name",
                "model",
                "owner",
                "farm_name",
                "contact_number",
                "sg_code",
                "email",
                "contact_person_01",
                "contact_number_01",
                "meter_number",
                "location_name",
                "modem_no",
                "pressure_meter",
                "district",
                "sub_district",
                "sub_sub_district",
                "lat",
                "lon",
                "alt",
                "summer_area",
                "summer_vol",
                "winter_area",
                "winter_vol",
                "pump_model",
                "impeller_size",
                "motor_kw",
                "motor_speed",
                "vsd_model",
                "pump_max_flowrate",
                "pump_max_head",
                "pump_min_flowrate",
                "pump_min_head",
                "pump_zero_flow",
                "pump_guideline_max_flowrate",
                "pump_guideline_max_head",
                "pump_guideline_min_flowrate",
                "pump_guideline_min_head",
                "pump_optimum_flowrate",
                "pump_optimum_head",
                "pump_efficiency",
                "pump_power_use",
                "water_dial_redline",
                "water_suction_head",
                "water_sensor_height",
                "water_min_level",
              ],
              output: "json",
              delimiter: ";",
            })
              .fromString(content)
              .then((data) => {
                this.onDeviceImport(data);
              });
          } else {
            csv({
              noheader: false,
              headers: ["snr", "name"],
              output: "json",
            })
              .fromString(content)
              .then((data) => {
                this.onDeviceImport(data);
              });
          }
        };

        reader.readAsText(file);
      }
    });

    this.setupCustom();
  }

  setupCustom() {
    var input = document.querySelector("#user_phoneInput");
    this.user_phoneInput = (window as any).intlTelInput(input, {
      nationalMode: false,
      separateDialCode: true,
      formatOnDisplay: true,
      preferredCountries: ["za"],
      placeholderNumberType: "MOBILE",
      utilsScript: "assets/intlPhone/js/utils.js",
      customPlaceholder: (
        selectedCountryPlaceholder: any,
        selectedCountryData: any
      ) => {
        return "e.g. " + selectedCountryPlaceholder;
      },
    });

    //CSS fixes
    $(".iti").css("width", "100%");
    $(".iti__flag-container").css("padding", "0px");
  }
  getNumber(): string {
    let number: string = this.user_phoneInput.getNumber(
      intlTelInputUtils.numberFormat.E164
    );

    //Remove the plus prefix
    number = number.replace("+", "");

    return number;
  }
  onCustomChange() {
    //Get the defaults
    let address: string = $("#device-address").val();
    let label = address;
    let isNumber = address.match(/^[0-9]*$/gm);

    //Phone number or username?
    if (isNumber != null) {
      //Validate the phone number
      let isValid = this.user_phoneInput.isValidNumber();

      //Format the address and label
      if (isValid) {
        address = this.getNumber();
        label = `Phone (${address})`;
      } else {
        address = undefined;
      }
    }

    //Update display
    this.user_phone_disp = address;
  }

  hasUserAccess() {
    return this.globals.permitSingle(AccessGroup.people, AccessLevel.VIEW_L2);
  }

  hasLinkedUserAccess() {
    return this.globals.permitSingle(AccessGroup.people, AccessLevel.EXECUTE);
  }

  hasGroupAccess() {
    return this.globals.permitSingle(AccessGroup.orgunits, AccessLevel.EXECUTE);
  }

  hasDeviceAccess() {
    return this.globals.permitSingle(AccessGroup.iot, AccessLevel.EDIT);
  }

  hasAgentAccess() {
    return this.globals.permitSingle(AccessGroup.account, AccessLevel.CREATE);
  }

  hasRootSuperAccess() {
    return this.globals.permitSingle(
      AccessGroup.account,
      AccessLevel.EXECUTE_L1
    );
  }

  hasSwitchAccountAccess() {
    return this.globals.permitSingle(AccessGroup.account, AccessLevel.CREATE);
  }

  createPersonsTable() {
    //Keep a reference to this
    let me = this;

    //Create the people data-table
    this.peopleTable = $("#people-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      language: {
        searchPlaceholder:
          "Search " + me.globals.buildSettings.usersHeader + "s",
      },
      initComplete: function () {},
      columns: [
        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "column-bold",
        },

        {
          data: "role",
          orderable: true,
          searchable: false,
          className: "text-center",
        },
        {
          data: "group",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/people/page",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
            simpleSearch: true,
            forceFilterOrgUnits:me.globals.userAccess.role == "owner" ? true : false // Only if owner and below
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let personid = response.data[i].personid;
            let isoDate = new Date(response.data[i].datetime);
            let personRole = response.data[i].role;
            let tools = me.buildToolsField(
              personid,
              personRole,
              response.data[i]
            );

            let unforgunits =
              response.data[i].orgunits &&
              response.data[i].orgunits != "" &&
              response.data[i].orgunits != "All"
                ? response.data[i].orgunits
                : "All";
            let orgunits = unforgunits.split(",");

            response.data[i].group = orgunits[0];
            if (orgunits && orgunits.length > 0 && orgunits[0] != "All") {
              if (orgunits.length == 1) {
                response.data[i].group = orgunits[0];
              } else {
                let count = orgunits.length;
                response.data[i].group = "Multiple (" + count + ")";
              }
            }

            //Reformat
            response.data[i].DT_RowId = personid;
            response.data[i].tools = tools.html;
            // response.data[i].tools = "";
            response.data[i].datetime = moment(isoDate).format(
              me.globals.dateTimeFormat
            );
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    // dash-linked-user
    me.peopleTable.on("click", ".dash-linked-user", function () {
      let tr = $(this).closest("tr");
      let data = me.peopleTable.row(tr[0]).data();
      let access = !data.dash_access;

      me.globals.peopleEdit(
        data.personid,
        data.name,
        undefined,
        undefined,
        undefined,
        undefined,
        data.role,
        undefined,
        () => {
          //Success
          me.peopleTable.ajax.reload(null, false);
        },
        () => {
          //Failure
        },
        access
      );

      console.log("change dash access");
    });

    //Edit click
    me.peopleTable.on("click", ".edit-user", function () {
      let tr = $(this).closest("tr");
      let data = me.peopleTable.row(tr[0]).data();
      me.editPerson(data);
    });

    //Remove click
    me.peopleTable.on("click", ".remove-user", function () {
      //Ask
      me.globals.showWarningAlert(
        "Remove user",
        "Are you sure you want to remove this user permanently?",
        () => {
          let tr = $(this).closest("tr");
          let data = me.peopleTable.row(tr[0]).data();
          me.removePerson(data);
        }
      );
    });

    me.peopleTable.on("click", ".edit-orgunits", function () {
      let tr = $(this).closest("tr");
      let data = me.peopleTable.row(tr[0]).data();

      //unpack orgunits and orgids
      let unforgunits =
        data.orgunits && data.orgunits != "" && data.orgunits != "All"
          ? data.orgunits.split(",")
          : {};
      let unforgids =
        data.orgids && data.orgids != "" && data.orgids != "All"
          ? data.orgids.split(",")
          : {};

      //Build list
      let orgs = [];

      for (var i = 0; i < unforgunits.length; i++) {
        let org = {
          id: unforgids[i],
          name: unforgunits[i],
          personid: data.personid,
        };

        orgs.push(org);
      }

      me.linkedOrgs = orgs;
      me.selecteduser.personid = data.personid;

      //Show all linked orgs with option to add more. Show in modal
      me.linkedUserOrgTable.ajax.reload(null, false);
      me.anon = false;
      $("#modal-link-users-orgs").modal("show");
    });
  }

  createPersonOrgunitsTable() {
    //Keep a reference to this
    let me = this;

    //Create the people data-table
    this.linkedUserOrgTable = $("#people-org-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      language: {
        searchPlaceholder:
          "Search " + me.globals.buildSettings.groupsHeader + "s",
      },
      initComplete: function () {},
      columns: [
        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "column-bold",
        },

        {
          data: "linked",
          orderable: false,
          searchable: false,
          className: "text-center",
        },

        //  {
        //      data: "tools",
        //      "orderable": false,
        //      searchable: false,
        //      className: "col-tools text-center column-nowrap"
        //  }
      ],
      ajax: {
        url: me.globals.apiRootNew + "/orgunits/page",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let orgid = response.data[i].orgid;
            //  let isoDate = new Date(response.data[i].datetime);
            response.data[i].tools = "";
            response.data[i].linked = response.data[i].orgid;

            //Show linked if orgid is in linkedorgid list
            let ind = me.globals.arrayFindWithAttr(
              me.linkedOrgs,
              "id",
              response.data[i].orgid
            );

            if (ind != -1) {
              response.data[i].linked =
                '<a><i class="far fa-fw fa-check-circle toggle-selection" style="cursor:pointer;" title="Remove person from this site"></i></a>';
              response.data[i].linkedFlag = true;
            } else {
              response.data[i].linked =
                '<a><i class="far fa-fw fa-circle toggle-selection" style="cursor:pointer;" title="Assign member to this site"></i></a>';
              response.data[i].linkedFlag = false;
            }
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    me.linkedUserOrgTable.on("click", ".toggle-selection", function () {
      let tr = $(this).closest("tr");
      let data = me.linkedUserOrgTable.row(tr[0]).data();

      let linked = data.linkedFlag;
      let orgunit = {
        id: data.orgid,
        name: data.name,
        personid: me.selecteduser.personid,
      };

      //Link user or remove user;
      if (!me.anon) {
        me.globals.orgUnitRelate(
          me.selecteduser.personid,
          data.orgid,
          linked,
          () => {
            //Success
            if (linked) {
              //Remove orgunit from linked orgunits
              me.linkedOrgs = me.linkedOrgs.filter(
                (item) => item.id != data.orgid
              );
            } else {
              //Add orgunit to linked orgunits
              me.linkedOrgs.push(orgunit);
            }

            //Refresh peopleTabe and linkedUserOrgTable
            me.peopleTable.ajax.reload();
            me.linkedUserOrgTable.ajax.reload();
          },
          () => {
            //Failure
          }
        );
      } else {
        me.globals.orgUnitRelateAnon(
          me.selecteduser.personid,
          data.orgid,
          linked,
          () => {
            //Success
            if (linked) {
              //Remove orgunit from linked orgunits
              me.linkedOrgs = me.linkedOrgs.filter(
                (item) => item.id != data.orgid
              );
            } else {
              //Add orgunit to linked orgunits
              me.linkedOrgs.push(orgunit);
            }

            //Refresh peopleTabe and linkedUserOrgTable
            me.peopleTable.ajax.reload();
            me.linkedUserOrgTable.ajax.reload();
          },
          () => {
            //Failure
          }
        );
      }
    });
  }

  editPerson(data) {
    this.selecteduser.name = data.name;
    this.selecteduser.role = data.role;
    this.selecteduser.personid = data.personid;
    this.selecteduser.group = data.group;
    this.selecteduser.data = data;

    //Show modal
    $("#edit-user").modal("show");
  }

  removePerson(data) {
    //Keep reference
    let me = this;
    let name = data.name;
    let username = data.username;

    this.globals.showConfirmAlert(
      "Confirmation",
      "Remove <b>" + name + "</b> permanently?",
      "YES",
      "CANCEL",
      () => {
        this.globals.peopleDelete(
          data.personid,
          username,
          () => {
            me.peopleTable.ajax.reload(null, false);
            //  this.globals.showNotification("success", "top", "right", "Removed " + name + " successfully.");

            //Delete member too
          },
          () => {
            //TODO: show error
          }
        );
      }
    );
  }

  buildToolsField(personid, role, person?: any) {
    let myRole = this.globals.userAccess.role;

    // let ind = this.globals.arrayFindWithAttr(this.globals.roles,"","")
    //Format the HTML
    let removeHtml = `<a style="cursor: pointer;" title="Remove the ${this.globals.buildSettings.usersHeader}" class="remove-user"><i class="fal fa-fw fa-trash-alt saf-action" aria-hidden="true"></i></a>`;
    let editHtml = `<a style="cursor: pointer;" title="Edit ${this.globals.buildSettings.usersHeader}" class="edit-user"><i class="fal fa-fw fa-pencil-alt saf-action" aria-hidden="true"></i></a>`;
    let editOrgUnits = `<a style="cursor: pointer;" title="Edit linked sites" class="edit-orgunits"><i class="fal fa-fw fa-users-cog saf-action" aria-hidden="true"></i></a>`;

    //Add dashaccess link
    let activeLinkedUser = ``;
    if (person && person.role == "user") {
      if (person.dash_access) {
        //Linked
        activeLinkedUser = `<a style="cursor: pointer;" title="Remove dashboard access" class="dash-linked-user"><i class="fal fa-fw fa-check" aria-hidden="true"></i></a>`;
      } else {
        //Not linked
        activeLinkedUser = `<a style="cursor: pointer;" title="Grant dashboard access" class="dash-linked-user"><i class="fal fa-fw fa-times" aria-hidden="true"></i></a>`;
      }
    } else {
      //Is not 'user' therefore is linked
      activeLinkedUser = `<a style="cursor: pointer;" title="Has Access" class="linked-fixed"><i class="fal fa-fw fa-check" style="color:#d7d7d9 "aria-hidden="true"></i></a>`;
    }

    if (this.globals.roles.includes(role)) {
      return {
        id: personid,
        html:
          editHtml +
          "&nbsp;&nbsp;" +
          removeHtml +
          "&nbsp;&nbsp;" +
          editOrgUnits +
          "&nbsp;&nbsp;" +
          activeLinkedUser,
      };
    } else {
      return {
        id: personid,
        html: "",
      };
    }
  }

  manageUsers() {
    //Get list of orgunits
    this.globals.orgunitList(
      (r: any) => {
        //Success
        this.orgunitsList = r.data;
        //update table
        this.peopleTable.ajax.reload();

        $("#show-manage-users").modal("show");
      },
      () => {
        //Failure
      }
    );
  }

  saveUser() {
    let me = this;

    //Update the other user info
    this.globals.peopleEdit(
      this.selecteduser.personid,
      this.selecteduser.name,
      undefined,
      undefined,
      undefined,
      undefined,
      this.selecteduser.role,
      undefined,
      () => {
        //Success
        me.peopleTable.ajax.reload(null, false);
      },
      () => {
        //Failure
      }
    );
  }

  showAddUser() {
    $("#add-user").modal("show");
  }

  clearUser() {
    //Clear vars
    $("#add-user-username").val("");
    $("#add-user-name").val("");
    $("#add-user-email").val("");
    $("#add-user-role").val("");
    $("#add-user-group").val("");
  }

  addUser() {
    let me = this;
    let username: string = $("#add-user-email").val();
    let name: string = $("#add-user-name").val();
    let email: string = $("#add-user-email").val();
    let role: string = $("#add-user-role").val();
    let groupName: string = $("#add-user-group").val();
    let phone: string = this.getNumber();

    //Check values exist
    if (
      username &&
      username != "" &&
      name &&
      name != "" &&
      email &&
      email != "" &&
      role &&
      role != "" &&
      phone &&
      phone != "" &&
      phone.length > 9
    ) {
      //HERE: link if already a user in another account
      if (this.globals.validateEmail(email)) {
        //Create Password
        let password: string = generator.generate();
        email = email.toLowerCase();
        username = username.toLowerCase();

        this.globals.peopleAdd(
          name,
          email,
          role,
          username,
          password,
          phone,
          (res) => {
            //Success
            email = email.toLowerCase();

            this.globals.showSuccessAlert(
              "Temporary Password",
              "The password for " +
                email +
                " is:<br><br><b>" +
                password +
                "</b>"
            );

            //Add user to group/orgunit
            if (groupName && groupName != "All") {
              //Get orgid
              let ind = this.globals.arrayFindWithAttr(
                this.orgunitsList,
                "name",
                groupName
              );
              this.globals.orgUnitRelate(
                res.personid,
                this.orgunitsList[ind].orgid,
                false,
                () => {
                  me.peopleTable.ajax.reload();
                }
              );
            }

            //Notify user
            let recipients = [email];

            this.globals.accountNewUserNotify(
              recipients,
              "New user created",
              email,
              password,
              name
            );

            //Clear vars
            $("#add-user-username").val("");
            $("#add-user-name").val("");
            $("#add-user-email").val("");
            $("#add-user-role").val("");
            $("#add-user-group").val("");

            //Close modal
            $("#add-user").modal("hide");

            //reload table
            this.peopleTable.ajax.reload();
          },
          (r) => {
            //Error
            if (
              r.error &&
              r.message &&
              r.error == 107 &&
              r.message == "Email already registered"
            ) {
              //Ask to link
              this.globals.showConfirmAlert(
                "Link User",
                "The user is already registered in another account. Do you want to link the user to this account?",
                "LINK",
                "Cancel",
                () => {
                  //Do link
                  this.globals.peopleLinkByEmail(
                    email,
                    role,
                    (person?: any) => {
                      if (person && person.personid) {
                        //Add to orgunit
                        let ind = this.globals.arrayFindWithAttr(
                          this.orgunitsList,
                          "name",
                          groupName
                        );
                        if (ind != -1) {
                          //Relate
                          this.globals.orgUnitRelateAnon(
                            person.personid,
                            this.orgunitsList[ind].orgid,
                            false,
                            () => {
                              me.peopleTable.ajax.reload();
                            }
                          );
                        }

                        //Clear vars
                        $("#add-user-username").val("");
                        $("#add-user-name").val("");
                        $("#add-user-email").val("");
                        $("#add-user-role").val("");
                        $("#add-user-group").val("");

                        //Close modal
                        $("#add-user").modal("hide");
                      } else {
                        //Could not link
                      }
                    },
                    () => {
                      //Could not link
                    }
                  );
                },
                () => {
                  //Clear vars
                  $("#add-user-username").val("");
                  $("#add-user-name").val("");
                  $("#add-user-email").val("");
                  $("#add-user-role").val("");
                  $("#add-user-group").val("");

                  //Close modal
                  $("#add-user").modal("hide");
                }
              );
            } else {
              this.globals.showWarningAlert("Error", r.message);
            }
          }
        );
      } else {
        this.globals.showWarningAlert("Error", "Email format is not correct.");
      }
    } else {
      this.globals.showWarningAlert(
        "Error",
        "User could not be added. Please confirm that all the fields are valid."
      );
    }
  }

  switchAccounts() {
    $("#modal-change-account").modal("show");
  }

  showOnboardUsers() {
    // show-onboard-users"
    this.userOnboardingTable.ajax.reload();
    $("#show-onboard-users").modal("show");
  }

  createUserOnboardingTable() {
    //"onboard-users-table"
    // userOnboardingTable

    //Keep a reference to this
    let me = this;

    //Create the people data-table
    this.userOnboardingTable = $("#onboard-users-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      language: {
        searchPlaceholder:
          "Search " + me.globals.buildSettings.usersHeader + "s",
      },
      initComplete: function () {
        //Chrome bug
        $(this.api().table().container())
          .find("input")
          .parent()
          .wrap("<form>")
          .parent()
          .attr("autocomplete", "off");
      },
      columns: [
        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "column-bold",
        },
        {
          data: "username",
          orderable: true,
          searchable: false,
          className: "text-center",
        },
        {
          data: "group",
          orderable: false,
          searchable: true,
          className: "text-center",
        },

        // {
        //     data: "accepted_devices",
        //     "orderable": false,
        //     searchable: false,
        //     className: "text-center"

        // },
        // {
        //     data: "rejected_devices",
        //     "orderable": false,
        //     searchable: false,
        //     className: "text-center"
        // },
        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/people/page",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
            agent: true,
            simpleSearch: false,
            getAgentOrgunits: true,
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let person = response.data[i];
            let personid = response.data[i].personid;
            let tools = me.buildAgentToolsField(person);
            let username = response.data[i].address;

            //Reformat
            response.data[i].DT_RowId = personid;
            response.data[i].tools = tools.html;
            response.data[i].username = username;
            response.data[i].cellphone = " ";
            response.data[i].accepted_devices = " ";
            response.data[i].rejected_devices = " ";

            let unforgunits =
              response.data[i].orgunits &&
              response.data[i].orgunits != "" &&
              response.data[i].orgunits != "All"
                ? response.data[i].orgunits
                : "All";
            // let orgunits = unforgunits.split(",");
            let orgunits = unforgunits;

            //Filter orgunits with the orgunits in this site
            orgunits = me.filterAgentOrgunits(orgunits);

            response.data[i].group = orgunits;

            if (orgunits && orgunits.length > 0 && orgunits != "All") {
              if (orgunits.length == 1) {
                response.data[i].group = orgunits[0].name;
              } else {
                let count = orgunits.length;
                response.data[i].group = "Multiple (" + count + ")";
              }
            }

            // let isoDate = new Date(response.data[i].datetime);
            // response.data[i].datetime = moment(isoDate).format(me.globals.dateTimeFormat);
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    //User Dashboard access click
    me.userOnboardingTable.on("click", ".dash-linked-agent", function () {
      let tr = $(this).closest("tr");
      let data = me.userOnboardingTable.row(tr[0]).data();

      let access = !data.dash_access_linked;
      let accId = me.globals.entityAccid;
      let personId = data.personid;

      me.globals.peopleLinkAgentAnon(
        personId,
        access,
        () => {
          me.userOnboardingTable.ajax.reload(null, false);
        },
        () => {
          //Failure
        }
      );

      // me.globals.peopleLinkByEmail(data.username, data.role, (person ? : any) =>
      // {
      //     me.userOnboardingTable.ajax.reload(null, false);
      // }, () =>
      // {
      //     //Failure
      // }, access)
      //Update person account table
      //link as agent
      //Refresh table
    });

    //Remove click
    me.userOnboardingTable.on("click", ".remove-agent", function () {
      me.globals.showWarningAlert(
        "Remove user",
        "Are you sure you want to remove this user permanently from this account?",
        () => {
          //TODO: ask if must remove
          let tr = $(this).closest("tr");
          let data = me.userOnboardingTable.row(tr[0]).data();
          me.removeAgent(data);
        }
      );
    });

    //Activate click
    me.userOnboardingTable.on("click", ".activate-agent", function () {
      let tr = $(this).closest("tr");
      let data = me.userOnboardingTable.row(tr[0]).data();
      me.activateAgent(data);
    });

    me.userOnboardingTable.on(
      "click",
      ".edit-linked-user-orgunits",
      function () {
        let tr = $(this).closest("tr");
        let data = me.userOnboardingTable.row(tr[0]).data();

        //unpack orgunits and orgids
        let unforgunits =
          data.orgunits && data.orgunits != "" && data.orgunits != "All"
            ? data.orgunits
            : {};

        //Build list
        let orgs = [];

        for (var i = 0; i < unforgunits.length; i++) {
          let org = {
            id: unforgunits[i].orgid,
            name: unforgunits[i].name,
            personid: data.personid,
          };

          orgs.push(org);
        }

        me.linkedOrgs = orgs;
        me.selecteduser.personid = data.personid;

        //Show all linked orgs with option to add more. Show in modal
        me.linkedUserOrgTable.ajax.reload(null, false);
        me.anon = true;
        $("#show-onboard-users").modal("hide");
        $("#modal-link-users-orgs").modal("show");
      }
    );
  }

  filterAgentOrgunits(orgunits: any) {
    let orgs = [];
    let retOrgs: any;
    // this.orgunitsList
    if (
      orgunits != "All" &&
      orgunits.length > 0 &&
      this.orgunitsList &&
      this.orgunitsList.length > 0
    ) {
      for (let i = 0; i < orgunits.length; i++) {
        let org = orgunits[i];

        //Find org in orgunitsList
        let ind = this.globals.arrayFindWithAttr(
          this.orgunitsList,
          "orgid",
          org.orgid
        );
        if (ind != -1 && this.orgunitsList) {
          let myOrg = this.orgunitsList[ind];
          orgs.push(myOrg);
        }
      }
      if (orgs.length == 0) {
        retOrgs = "All";
      } else {
        retOrgs = orgs;
      }
    } else {
      retOrgs = "All";
    }

    return retOrgs;
  }

  buildAgentToolsField(data: any, showWaiting?: boolean) {
    //Execute permissions
    let can_execute = this.globals.permitSingle(
      AccessGroup.people,
      AccessLevel.EXECUTE
    );

    //Format the HTML
    let removeHtml =
      '<a style="cursor: pointer;" title="Remove the agent" class="remove-agent"><i class="fal fa-fw fa-trash-alt" aria-hidden="true"></i></a>';
    var activeHtml;
    let editOrgUnits = `<a style="cursor: pointer;" title="Edit linked sites" class="edit-linked-user-orgunits"><i class="fal fa-fw fa-users-cog saf-action" aria-hidden="true"></i></a>`;

    if (showWaiting !== true) {
      activeHtml =
        '<a style="cursor: pointer;" title="Activate/deactivate the agent" class="activate-agent"><i class="fal fa-fw ' +
        (data.active ? "fa-toggle-on" : "fa-toggle-off") +
        '" aria-hidden="true"></i></a>';
    } else {
      activeHtml = '<i class="far fa-fw fa-sync fa-spin"></i>';
    }

    //TODO : Set dashactive options according to role and dash_access_linked variable
    // check, times
    let activeLinkedUser = ``;
    if (data.role == "user") {
      if (data.dash_access_linked) {
        //Linked
        activeLinkedUser = `<a style="cursor: pointer;" title="Remove dashboard access" class="dash-linked-agent"><i class="fal fa-fw fa-check" aria-hidden="true"></i></a>`;
      } else {
        //Not linked
        activeLinkedUser = `<a style="cursor: pointer;" title="Grant dashboard access" class="dash-linked-agent"><i class="fal fa-fw fa-times" aria-hidden="true"></i></a>`;
      }
    } else {
      //Is not 'user' therefore is linked
      activeLinkedUser = `<a style="cursor: pointer;" title="Has Access" class="linked-fixed"><i class="fal fa-fw fa-check" style="color:#d7d7d9 "aria-hidden="true"></i></a>`;
    }

    //Hide the tools column if not needed
    this.userOnboardingTable.columns(".col-tools").visible(can_execute);

    return {
      id: data.personid,
      html: can_execute
        ? activeHtml +
          "&nbsp;&nbsp;" +
          removeHtml +
          "&nbsp;&nbsp;" +
          editOrgUnits +
          "&nbsp;&nbsp;" +
          activeLinkedUser
        : "",
    };
  }

  removeAgent(data) {
    this.globals.showConfirmAlert(
      "Confirmation",
      "Remove agent " + data.name + "?",
      "YES",
      "CANCEL",
      () => {
        //Helpers
        let personid = data.personid;
        let tools = this.buildAgentToolsField(data, true);

        //Set the sync icon
        let td = $("#" + personid).find("td:eq(3)");
        td.html(tools.html);

        //Do request
        this.globals.peopleLinkAgent(
          personid,
          false,
          true,
          () => {
            //Refresh the whole table
            this.userOnboardingTable.ajax.reload(null, false);
          },
          () => {
            //Remove the waiting status
            let tools = this.buildAgentToolsField(data, false);
            td.html(tools.html);
          }
        );
      }
    );
  }

  activateAgent(data) {
    //Locals
    let personid = data.personid;
    let active = !data.active;
    let tools = this.buildAgentToolsField(data, true);

    //Set the sync icon
    let td = $("#" + personid).find("td:eq(3)");
    td.html(tools.html);

    //Do request
    this.globals.peopleLinkAgent(
      personid,
      active,
      false,
      () => {
        //Update and remove the waiting status
        data.active = active;
        let tools = this.buildAgentToolsField(data, false);
        td.html(tools.html);
      },
      () => {
        //Remove the waiting status
        let tools = this.buildAgentToolsField(data, false);
        td.html(tools.html);
      }
    );
  }

  //-------------------- GROUPS--------------------//
  createGroupTable() {
    let me = this;

    this.groupTable = $("#group-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,

      language: {
        searchPlaceholder:
          "Search " + me.globals.buildSettings.groupsHeader + "s",
      },
      initComplete: function () {},
      columns: [
        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "column-bold",
        },
        {
          data: "description",
          orderable: true,
          searchable: true,
        },

        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/orgunits/page",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
            simpleSearch: true,
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let orgid = response.data[i].orgid;
            // let isoDate = new Date(response.data[i].datetime);
            let tools = me.buildToolsFieldGroups(orgid);

            //Reformat
            response.data[i].DT_RowId = orgid;
            response.data[i].tools = tools.html;
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    //Edit click
    me.groupTable.on("click", ".edit-group", function () {
      let tr = $(this).closest("tr");
      let data = me.groupTable.row(tr[0]).data();
      me.editGroup(data);
    });

    //Remove click
    me.groupTable.on("click", ".remove-group", function () {
      let tr = $(this).closest("tr");
      let data = me.groupTable.row(tr[0]).data();
      me.removeGroup(data);
    });

    //Reference click
    me.groupTable.on("click", ".ref-group", function () {
      let tr = $(this).closest("tr");
      let data = me.groupTable.row(tr[0]).data();
      me.showReference(data);
    });
  }

  showReference(data) {
    this.selectedGroup.classid = data.classid;
    this.globals.classGet(data.classid, (r: any) => {
      this.selectedGroup.reference = r.reference;
      this.selectedClass = r;
      delete this.selectedClass["id"];
      delete this.selectedClass["container"];
      delete this.selectedClass["created"];

      //Show modal
      $("#show-site-ref").modal("show");
    });
  }

  updateSiteId() {
    let newRef = $("#site-id-info").val();
    this.selectedClass.reference = newRef;

    this.globals.classSet(
      this.selectedGroup.classid,
      this.selectedClass,
      (r: any) => {
        $("#show-site-ref").modal("hide");
      }
    );
  }

  editGroup(data) {
    this.selectedGroup.name = data.name;
    this.selectedGroup.description = data.description;
    this.selectedGroup.orgid = data.orgid;
    this.selectedGroup.classid = data.classid;

    //Show modal
    $("#edit-group").modal("show");
  }

  removeGroup(data) {
    //Keep reference
    let me = this;
    let name = data.name;
    let classes = [data.classid];

    //Get class
    this.globals.classList(
      classes,
      (res: any) => {
        //Remove only if usercount = 0
        if (data.user_cnt && data.user_cnt > 0) {
          this.globals.showWarningAlert(
            "Error",
            "You cannot delete the groups as it has users/devices assigned to it."
          );
        } else {
          if (res && res[0] && res[0].devicecount && res[0].devicecount > 0) {
            this.globals.showWarningAlert(
              "Error",
              "You cannot delete the groups as it has users/devices assigned to it."
            );
          } else {
            this.globals.showConfirmAlert(
              "Confirmation",
              "Remove <b>" + name + "</b> permanently?",
              "YES",
              "CANCEL",
              () => {
                this.globals.orgUnitDelete(
                  data.orgid,
                  () => {
                    //Delete class
                    me.globals.classRemove(data.classid, (r: any) => {
                      // me.groupTable.ajax.reload(null, false);
                      $("#centerIframe").attr(
                        "src",
                        $("#centerIframe").attr("src")
                      );
                    });

                    me.groupTable.ajax.reload(null, false);
                    me.peopleTable.ajax.reload(null, false);
                    me.deviceTable.ajax.reload(null, false);
                    $("#centerIframe").attr(
                      "src",
                      $("#centerIframe").attr("src")
                    );
                  },
                  () => {
                    this.globals.showWarningAlert(
                      "Error",
                      "An error occured during deleting procedure. Group cannot be deleted."
                    );
                  }
                );
              }
            );
          }
        }
      },
      () => {}
    );
  }

  buildToolsFieldGroups(personid) {
    //Format the HTML
    let removeHtml = `<a style="cursor: pointer;" title="Remove the ${this.globals.buildSettings.groupsHeader}" class="remove-group"><i class="saf saf-delete saf-action" aria-hidden="true"></i></a>`;
    let editHtml = `<a style="cursor: pointer;" title="Edit the ${this.globals.buildSettings.groupsHeader}" class="edit-group"><i class="saf saf-edit saf-action" aria-hidden="true"></i></a>`;
    let infoHtml = `<a style="cursor: pointer;" title="${this.globals.buildSettings.groupsHeader} reference" class="ref-group"><i class="saf saf-menu  saf-action" aria-hidden="true"></i></a>`;

    return {
      id: personid,
      html: editHtml + "&nbsp;&nbsp;" + removeHtml + "&nbsp;&nbsp;" + infoHtml,
    };
  }

  saveGroup() {
    let me = this;

    this.globals.orgUnitEdit(
      this.selectedGroup.orgid,
      this.selectedGroup.name,
      this.selectedGroup.description,
      undefined,
      undefined,
      undefined,
      undefined,
      () => {
        //get class
        this.globals.classGet(this.selectedGroup.classid, (r: any) => {
          let newclass = r;

          newclass.name = this.selectedGroup.name;

          this.globals.classSet(
            this.selectedGroup.classid,
            newclass,
            (r: any) => {
              // Success
              me.groupTable.ajax.reload(null, false);
              $("#centerIframe").attr("src", $("#centerIframe").attr("src"));
            }
          );
        });
      },
      () => {
        //Failure
      }
    );
  }

  manageGroups() {
    this.groupTable.ajax.reload();
    $("#show-manage-groups").modal("show");
  }

  showAddGroup() {
    $("#add-group").modal("show");
  }

  clearGroup() {
    $("#add-group-name").val("");
    $("#add-group-descr").val("");
  }

  addGroup() {
    let me = this;

    let name = $("#add-group-name").val();
    let descr = $("#add-group-descr").val();
    let typeName = $("#add-group-type").val();
    let collectorVal = $("#add-group-collector").val();
    let flavour = this.globals.buildSettings.appFlavour;

    //TODO: get specifics and rules from type
    let classTypes = this.globals.buildSettings.classTypes;
    let i = this.globals.arrayFindWithAttr(classTypes, "name", typeName);

    //Get specifics + rules
    let specifics = [];
    let rules = [];

    if (i != -1) {
      specifics = classTypes[i].specifics;
      rules = classTypes[i].rules;
    }

    //Add Collector
    let collector = {
      value: collectorVal,
      type: "string",
      meta: null,
      key: "collector",
    };
    specifics.push(collector);

    let ref: string = generator.generate();

    let classObj = {
      name: name,
      enabled: true,
      inherit: false,
      parent: undefined,
      specifics: specifics,
      reference: ref,
      flavour: flavour,
    };

    //Add class
    this.globals.classAdd(
      classObj,
      (res: any) => {
        //Success
        //add orgunit
        me.globals.orgUnitAdd(
          name,
          descr,
          undefined,
          undefined,
          undefined,
          res.id,
          () => {
            //Success
            this.globals.orgunitList(
              (r: any) => {
                //Success
                this.orgunitsList = r.data;
                this.groupTable.ajax.reload();
                $("#centerIframe").attr("src", $("#centerIframe").attr("src"));
              },
              () => {
                //Failures
              }
            );

            $("#add-group-name").val("");
            $("#add-group-descr").val("");

            //Close modal
            $("#add-group").modal("hide");
          },
          () => {
            //Failure
            // console.log("failure")
          }
        );

        //Add rules if defined
        if (rules && rules.length > 0) {
          for (let j = 0; j < rules.length; j++) {
            let rule = rules[j];
            rule.class = res.id;
            rule.enabled = true;

            me.globals.ruleAdd(rule, (res) => {
              //Successfully added rule
            });
          }
        }
      },
      () => {
        //Failure
      }
    );
  }
  //-------------------- DEVICES--------------------//

  clearDevice() {
    $("#new-device-snr").val("");
    $("#new-device-name").val("");
    $("#new-user-group").val("");
    $("#new-device-iccid").val("");
    $("#new-device-imsi").val("");
    $("#new-device-imei").val("");
  }

  addDevices() {
    this.showAddDeviceModal();
  }

  showAddDeviceModal() {
    //Get list of orgunits
    this.globals.orgunitList(
      (r: any) => {
        //Success
        this.orgunitsList = r.data;
        $("#add-device").modal("show");
      },
      () => {
        //Failure
      }
    );
  }

  createDeviceTable() {
    let me = this;
    this.deviceTable = $("#device-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      // autoWidth: false,
      language: {
        searchPlaceholder:
          "Search " + me.globals.buildSettings.devicesHeader + "s",
      },
      initComplete: function () {},
      columns: [
        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "column-bold",
          width: "90px",
        },
        {
          data: "snr",
          orderable: true,
          searchable: true,
          width: "90px",
        },
        {
          data: "group",
          orderable: false,
          searchable: false,
          className: "text-center",
          width: "90px",
        },
        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/iot/proxy",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          let models: any = me.globals.getModels();
          let o = {
            token: me.globals.token,
            endpoint: "/device/page",
            body: {
              token: me.globals.iotToken,
              seq: data.draw,
              from: data.start,
              length: data.length,
              search: data.search.value,
              order: data.columns[data.order[0].column].data,
              direction: data.order[0].dir,
              simpleSearch: true,
              models: models,
            },
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.devices.length; i++) {
            //Extract some data
            let devid = response.data.devices[i].id;

            let tools = me.buildToolsFieldDevices(devid);

            //Reformat
            response.data.devices[i].DT_RowId = devid;
            response.data.devices[i].tools = tools.html;
            response.data.devices[i].classid = response.data.devices[i]
              .classes[0]
              ? response.data.devices[i].classes[0]
              : undefined;

            //Set extra device info fields defaults
            response.data.devices[i].imei = "";
            response.data.devices[i].iccid = "";
            response.data.devices[i].imsi = "";

            if (
              response.data.devices[i].specifics &&
              response.data.devices[i].specifics.length > 0
            ) {
              //Populate extra device info fields
              let specifics = response.data.devices[i].specifics;
              let indIMEI = me.globals.arrayFindWithAttr(
                specifics,
                "key",
                "imei"
              );
              let indICCID = me.globals.arrayFindWithAttr(
                specifics,
                "key",
                "iccid"
              );
              let indIMSI = me.globals.arrayFindWithAttr(
                specifics,
                "key",
                "imsi"
              );

              response.data.devices[i].imei =
                indIMEI != -1 ? specifics[indIMEI].value : "";
              response.data.devices[i].iccid =
                indICCID != -1 ? specifics[indICCID].value : "";
              response.data.devices[i].imsi =
                indIMSI != -1 ? specifics[indIMSI].value : "";

              // response.data.devices[i].iccid = "";
              // response.data.devices[i].imsi = "";
            }
            //Get group name
            if (response.data.devices[i].classid) {
              //Get orgname and id
              let orgidIndex = me.globals.arrayFindWithAttr(
                me.orgunitsList,
                "classid",
                response.data.devices[i].classid
              );

              if (orgidIndex >= 0) {
                response.data.devices[i].group =
                  me.orgunitsList[orgidIndex].name;
                response.data.devices[i].orgid =
                  me.orgunitsList[orgidIndex].orgid;
              } else {
                response.data.devices[i].group = "All";
                response.data.devices[i].orgid = undefined;
              }
            } else {
              response.data.devices[i].group = "All";
              response.data.devices[i].orgid = undefined;
            }
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.data.total,
            recordsFiltered: response.data.filtered,
            draw: response.data.seq,
            data: response.data.devices,
          });
        },
      },
    });

    //Edit click
    me.deviceTable.on("click", ".edit-device", function () {
      let tr = $(this).closest("tr");
      let data = me.deviceTable.row(tr[0]).data();
      me.editDevice(data);
    });

    //Remove click
    me.deviceTable.on("click", ".remove-device", function () {
      let tr = $(this).closest("tr");
      let data = me.deviceTable.row(tr[0]).data();
      me.removeDevice(data);
    });

    //Decommission click
    me.deviceTable.on("click", ".decommission-device", function () {
      let tr = $(this).closest("tr");
      let data = me.deviceTable.row(tr[0]).data();

      me.decommissionDevice(data);
    });
  }

  decommissionDevice(dev: any) {
    this.globals.showConfirmAlert(
      "Confirmation",
      "Decommision <b>" + dev.name + "</b>?",
      "YES",
      "CANCEL",
      () => {
        let id = dev.id;
        //Clear fields
        dev.state = {};
        dev.timezone = 2;
        dev.name = dev.snr;
        // dev.model = "";
        dev.host = "";
        dev.classes = [];
        dev.deployed = false;
        dev.specifics = this.clearSpecifics(dev.specifics);

        //remove unwanted fields
        delete dev.id;
        delete dev.container;
        delete dev.created;
        delete dev.classid;
        delete dev.DT_RowId;
        // delete dev.group;
        delete dev.iccid;
        delete dev.imei;
        delete dev.imsi;
        delete dev.orgid;
        delete dev.sim;
        delete dev.token;
        delete dev.tools;

        //Update device
        this.globals.deviceSet(
          id,
          dev,
          (res: any) => {
            //Remove data
            this.globals.rawDeleteAll(dev.snr, (result: any) => {
              //Refesh table
              this.deviceTable.ajax.reload();
            });
          },
          () => {
            //Failed
            // console.log("failed")
          }
        );
      }
    );
  }

  clearSpecifics(specifics: any) {
    //Clear values
    for (let i = 0; i < specifics.length; i++) {
      specifics[i].value = "";
    }

    return specifics;
  }

  editDevice(data) {
    this.selectedDevice.name = data.name;
    this.selectedDevice.group = data.group;
    this.selectedDevice.snr = data.snr;
    this.selectedDevice.orgid = data.orgid;
    this.selectedDevice.classid = data.classid;
    this.selectedDevice.devid = data.id;
    this.selectedDevice.model = data.model;

    //Show modal
    $("#edit-device").modal("show");
  }

  removeDevice(data) {
    //Keep reference
    let me = this;
    let name = data.name;

    this.globals.showConfirmAlert(
      "Confirmation",
      "Remove <b>" + name + "</b> permanently?",
      "YES",
      "CANCEL",
      () => {
        this.globals.deviceRemove(data.id, (r: any) => {
          me.deviceTable.ajax.reload();
          $("#centerIframe").attr("src", $("#centerIframe").attr("src"));
          me.deviceTable.columns.adjust();
        });
      }
    );
  }

  manageDevices() {
    this.deviceTable.ajax.reload();
    this.deviceTable.columns.adjust();
    $("#show-manage-devices").modal("show");
  }

  buildToolsFieldDevices(devid) {
    //Format the HTML
    let removeHtml = `<a style="cursor: pointer;" title="Remove the ${this.globals.buildSettings.devicesHeader}" class="remove-device"><i class="fal fa-fw fa-trash-alt saf-action" aria-hidden="true"></i></a>`;
    let editHtml = `<a style="cursor: pointer;" title="Edit the ${this.globals.buildSettings.devicesHeader}" class="edit-device"><i class="fal fa-fw fa-pencil-alt saf-action" aria-hidden="true"></i></a>`;
    let decomHtml = `<a style="cursor: pointer;" title="Decommission the ${this.globals.buildSettings.devicesHeader}" class="decommission-device"><i class="fal fa-fw fa-minus-octagon saf-action" aria-hidden="true"></i></a>`;

    // if (this.globals.hasAgentAccess) decomHtml = decomHtml = `<a style="cursor: pointer;" title="Decommission the ${this.globals.buildSettings.devicesHeader}" class="decommission-device"><i class="fal fa-fw fa-minus-octagon saf-action" aria-hidden="true"></i></a>`;
    let html =
      editHtml + "&nbsp;&nbsp;" + removeHtml + "&nbsp;&nbsp;" + decomHtml;

    //Check permissions
    // Add reset device connection
    // if (this.hasDeviceAccess())
    // {
    //     let resetConnectionHtml = '<a style="cursor: pointer;" title="Reset the device key" class="reset-device-connection"><i class="saf saf-action saf-shield" aria-hidden="true"></i></a>'
    //     html = html + "&nbsp;&nbsp;" + resetConnectionHtml;
    // }

    return {
      id: devid,
      html: html,
    };
  }

  addDevice() {
    //Get the name and serial number
    let name = $("#new-device-name").val();
    let snr = $("#new-device-snr").val();
    let group = $("#new-dev-group").val();
    let model = $("#new-dev-model").val();
    let flavour = this.globals.buildSettings.appName;

    // setup specifics
    let specifics = [];

    let classId = undefined;
    let classes = undefined;

    //Check for valid values
    if (
      name &&
      snr &&
      group &&
      name.length > 0 &&
      snr.length > 0 &&
      group.length > 0
    ) {
      //Get classId
      if (group && group != "All") {
        let ind = this.globals.arrayFindWithAttr(
          this.orgunitsList,
          "name",
          group
        );

        if (ind >= 0) {
          //Get classId
          classId = this.orgunitsList[ind].classid
            ? this.orgunitsList[ind].classid
            : undefined;
          classes = [classId];
        }
      }

      //Get device specifics
      let models = this.globals.buildSettings.models;
      let i = this.globals.arrayFindWithAttr(models, "code", model);

      //Get specifics + rules
      let specifics = [];

      if (i != -1) {
        specifics = models[i].specifics;
      }

      let snrs = [snr];

      this.globals.deviceVerify(
        snrs,
        (devs: any) => {
          if (devs && devs.success) {
            //Add device

            this.globals.deviceAdd(
              name,
              snr,
              model,
              classes,
              specifics,
              (res: any) => {
                //Clear the fields
                $("#new-device-snr").val("");
                $("#new-device-name").val("");
                $("#new-dev-group").val("");
                $("#new-dev-model").val("");

                //Close modal
                $("#add-device").modal("hide");

                //Refresh device table
                this.deviceTable.ajax.reload();
                this.deviceTable.columns.adjust();
                $("#centerIframe").attr("src", $("#centerIframe").attr("src"));

                //Retrieve all
                StatsComponent.instance.getDeviceData();
              },
              () => {}
            );
          } else {
            //Failure
            //First snr
            let snr = devs.snrs[0];
            this.globals.showWarningAlert(
              "Error",
              "Device already registered.<br> Serial Number: " + snr
            );
          }
        },
        () => {
          //Failure
          $("#update-account-button").prop("disabled", false);
          this.globals.showWarningAlert(
            "Error",
            "Request could not be completed."
          );
        }
      );
    } else {
      this.globals.showWarningAlert("Error", "Please enter all device fields.");
    }
  }

  saveDevice() {
    let me = this;

    let classes = [];

    //Get new classid from name
    if (
      this.selectedDevice &&
      this.selectedDevice.group &&
      this.selectedDevice.group &&
      this.selectedDevice.group != "All"
    ) {
      //Get new classid
      let ind = this.globals.arrayFindWithAttr(
        this.orgunitsList,
        "name",
        this.selectedDevice.group
      );
      let classid = this.orgunitsList[ind].classid;
      classes = [classid];
    }

    let device = {
      name: this.selectedDevice.name,
      model: this.selectedDevice.model,
      classes: classes,
    };

    this.globals.deviceSet(this.selectedDevice.devid, device, (res) => {
      //Reload device table
      me.deviceTable.ajax.reload();
      me.groupTable.ajax.reload();
      // me.deviceTable.columns.adjust();
      $("#centerIframe").attr("src", $("#centerIframe").attr("src"));
      AnalyticsComponent.redraw();
      StatsComponent.instance.getDeviceData();
    });
  }

  showBulkUploadDevices() {
    //Do not show device model if flocheck

    //show modal
    $("#show-bulk-upload-modal").modal("show");
  }

  onDeviceImport(data: any) {
    this.deviceData = data;
  }

  uploadBulkDevices(isFlowCheck: boolean = false) {
    //Do bulk  upload

    //Verify devices
    if (isFlowCheck) {
      this.uploadFlocheckBulk();
    } else {
      let snrs = [];
      let correctFormat = true;

      if (this.deviceData && this.deviceData.length > 0) {
        for (let i = 0; i < this.deviceData.length; i++) {
          let device = this.deviceData[i];

          if (
            device &&
            device.snr &&
            device.snr != "" &&
            device.snr.trim() != ""
          ) {
            //check if devices exists
            //Only add if not already added
            if (!snrs.includes(device.snr)) {
              snrs.push(device.snr);
            }
          } else {
            correctFormat = false;
          }
        }
      }
      //Build devices

      if (this.deviceData && this.deviceData.length > 0) {
        this.globals.deviceVerify(snrs, (devs: any) => {
          if (devs && devs.success) {
            //Add devices
            for (let i = 0; i < this.deviceData.length; i++) {
              let dev = this.deviceData[i];

              //Check if specifics must be added
              let specifics = [];
              //Get classId
              let group = $("#bulk-add-device-group").val();
              let classes = undefined;
              let classId = undefined;

              let model = $("#bulk-add-device-model").val();

              if (group && group != "All") {
                let ind = this.globals.arrayFindWithAttr(
                  this.orgunitsList,
                  "name",
                  group
                );

                if (ind >= 0) {
                  //Get classId

                  classId = this.orgunitsList[ind].classid
                    ? this.orgunitsList[ind].classid
                    : undefined;
                  classes = [classId];
                }
              }

              if (model && model != "") {
                //Fill specifics
                let models = this.globals.buildSettings.models;
                specifics = models[i].specifics;
              }

              let flavour = this.globals.buildSettings.appName;

              // this.globals.deviceAdd(
              //   dev.name,
              //   dev.snr,
              //   model,
              //   classes,
              //   specifics,
              //   (res: any) => {
              //     //Refresh device table
              //     $("#import-device-file").val("");
              //     this.deviceTable.ajax.reload();
              //     $("#centerIframe").attr(
              //       "src",
              //       $("#centerIframe").attr("src")
              //     );
              //     StatsComponent.instance.getDeviceData();
              //     AnalyticsComponent.redraw();
              //   },
              //   (res?: any) => {}
              // );
            }
          } else {
            //Failure
            //First snr
            let snr = devs.snrs[0];
            $("#update-account-button").prop("disabled", false);
            this.globals.showWarningAlert(
              "Error",
              "Device already registered.<br> Serial Number: " + snr
            );
          }
        });
      } else {
        this.globals.showWarningAlert("Error", "Please upload a file.");
      }
    }
  }

  uploadFlocheckBulk() {
    let snrs = [];
    let correctFormat = true;

    if (this.deviceData && this.deviceData.length > 0) {
      for (let i = 0; i < this.deviceData.length; i++) {
        let device = this.deviceData[i];

        if (
          device &&
          device.snr &&
          device.snr != "" &&
          device.snr.trim() != ""
        ) {
          //check if devices exists
          //Only add if not already added
          if (!snrs.includes(device.snr)) {
            snrs.push(device.snr);
          }
        } else {
          correctFormat = false;
        }
      }
    }
    if (this.deviceData && this.deviceData.length > 0) {
      this.globals.deviceVerify(snrs, (devs: any) => {
        if (devs && devs.success) {
          //Add devices
          for (let i = 0; i < this.deviceData.length; i++) {
            let dev = this.deviceData[i];
            let skip = false;
            let siteFound = false;
            //Check if specifics must be added
            let specifics = [];
            //Get classId
            let group = $("#bulk-add-device-group").val();
            let classes = undefined;
            let classId = undefined;

            let model = `agr.flo.${dev.model.toLowerCase()}`;

            if (dev.site && dev.site != "") {
              let ind = this.globals.arrayFindWithAttr(
                this.orgunitsList,
                "name",
                dev.site
              );

              if (ind >= 0) {
                //Get classId
                siteFound = true;

                classId = this.orgunitsList[ind].classid
                  ? this.orgunitsList[ind].classid
                  : undefined;
                classes = [classId];
              }
            }

            if (group && group != "All" && !siteFound) {
              let ind = this.globals.arrayFindWithAttr(
                this.orgunitsList,
                "name",
                group
              );

              if (ind >= 0) {
                //Get classId

                classId = this.orgunitsList[ind].classid
                  ? this.orgunitsList[ind].classid
                  : undefined;
                classes = [classId];
              }
            }

            if (model && model != "") {
              //Fill specifics
              let models = this.globals.buildSettings.models;
              let specsInd = this.globals.arrayFindWithAttr(
                models,
                "code",
                model
              );

              if (specsInd != -1) {
                specifics = models[specsInd].specifics;

                //Set specifics
                specifics = this.setFlocheckSpecifics(specifics, dev);
              } else {
                skip = true;
              }
            } else {
              skip = true;
            }

            let host = dev.modem_no;

            if (!skip) {
              this.globals.deviceAdd(
                dev.name,
                dev.snr,
                model,
                classes,
                specifics,
                (res: any) => {
                  //Refresh device table
                  $("#import-device-file").val("");
                  this.deviceTable.ajax.reload();
                  $("#centerIframe").attr(
                    "src",
                    $("#centerIframe").attr("src")
                  );
                  StatsComponent.instance.getDeviceData();
                  AnalyticsComponent.redraw();
                },
                (res?: any) => {},
                host
              );
            }
          }
        } else {
          //Failure
          //First snr
          let snr = devs.snrs[0];
          $("#update-account-button").prop("disabled", false);
          this.globals.showWarningAlert(
            "Error",
            "Device already registered.<br> Serial Number: " + snr
          );
        }
      });
    } else {
      this.globals.showWarningAlert("Error", "Please upload a file.");
    }
  }

  setFlocheckSpecifics(init: any, data: any) {
    //TODO: set specifics

    let cI = this.globals.arrayFindWithAttr(init, "key", "client_information");
    let mI = this.globals.arrayFindWithAttr(init, "key", "meter_information");
    let pC = this.globals.arrayFindWithAttr(
      init,
      "key",
      "pump_characteristics"
    );
    let pI = this.globals.arrayFindWithAttr(init, "key", "pump_information");
    let wL = this.globals.arrayFindWithAttr(init, "key", "water_level");

    //Set clientInformation:
    init[cI].value.contact_name_01 = data.owner;
    init[cI].value.farm_name = data.farm_name;
    init[cI].value.phone_01 = data.contact_number;
    init[cI].value.sg_code = data.sg_code;
    init[cI].value.email_01 = data.email;
    init[cI].value.phone_02 = data.contact_number_01;
    init[cI].value.contact_name_02 = data.contact_person_01;

    //Set meterInformation
    init[mI].value.meter_number = data.meter_number;
    init[mI].value.location_name = data.location_name;
    init[mI].value.modem_no = data.modem_no;
    init[mI].value.pressure_meter = data.pressure_meter;
    init[mI].value.district = data.district;
    init[mI].value.sub_district =
      data.sub_district == "" ? 0 : data.sub_district;
    init[mI].value.sub_sub_district =
      data.sub_sub_district == "" ? 0 : data.sub_sub_district;
    init[mI].value.latitude = data.lat;
    init[mI].value.longitude = data.lon;
    init[mI].value.altitude = data.alt;
    init[mI].value.summer_area = data.summer_area;
    init[mI].value.summer_vol = data.summer_vol;
    init[mI].value.winter_area = data.winter_area;
    init[mI].value.winter_vol = data.winter_vol;

    //PumpInformation
    init[pI].value.pump_model = data.pump_model;
    init[pI].value.impeller_size = data.impeller_size;
    init[pI].value.motor_output = data.motor_kw;
    init[pI].value.motor_speed = data.motor_speed;
    init[pI].value.vsd_model = data.vsd_model;

    //PumpCharacteristics
    init[pC].value.max_flowrate = data.pump_max_flowrate;
    init[pC].value.max_head = data.pump_max_head;
    init[pC].value.max_flowrate = data.pump_max_flowrate;
    init[pC].value.min_flowrate = data.pump_min_flowrate;
    init[pC].value.min_head = data.pump_min_head;
    init[pC].value.min_zero_kw = data.pump_zero_flow;
    init[pC].value.gmax_flowrate = data.pump_guideline_max_flowrate;
    init[pC].value.gmax_head = data.pump_guideline_max_head;
    init[pC].value.gmin_flowrate = data.pump_guideline_min_flowrate;
    init[pC].value.gmin_head = data.pump_guideline_min_head;
    init[pC].value.optimum_flowrate = data.pump_optimum_flowrate;
    init[pC].value.optimum_head = data.pump_optimum_head;
    init[pC].value.optimum_efficiency = data.pump_efficiency;
    init[pC].value.optimum_power = data.pump_power_use;

    //WaterLevel
    init[wL].value.wl_redline = data.water_dial_redline;
    init[wL].value.wl_suc_head = data.water_suction_head;
    init[wL].value.wl_redline = data.water_dial_redline;
    init[wL].value.wl_sensor_height = data.water_sensor_height;
    init[wL].value.wl_level = data.water_level;

    return init;
  }

  //-------------------- ACCOUNTS--------------------//
  manageAccounts() {
    this.accountsTable.ajax.reload();
    $("#show-manage-accounts").modal("show");
  }

  createAccountsTable() {
    //Keep a reference to this
    let me = this;

    //Create the people data-table
    this.accountsTable = $("#accounts-table").DataTable({
      paging: true,
      ordering: true,
      order: [[1, 'asc']],
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      language: {
        searchPlaceholder: "Search accounts",
      },
      initComplete: function () {},
      columns: [
        {
          data: "accid",
          orderable: true,
          searchable: true,
          className: "column-bold",
        },

        {
          data: "name",
          orderable: true,
          searchable: true,
          className: "text-center",
        },

        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/account/page",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.buildSettings.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);

          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let accid = response.data[i].accid;
            let active = response.data[i].active;
            let tools = me.buildAccountToolsField(accid, active);

            //Reformat
            response.data[i].DT_RowId = accid;
            response.data[i].tools = tools.html;

            // let isoDate = new Date(response.data[i].datetime);
            // // response.data[i].tools = "";
            // response.data[i].datetime = moment(isoDate).format(me.globals.dateTimeFormat);
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    //Hook buttons

    //GOTO click
    me.accountsTable.on("click", ".goto-account", function () {
      let tr = $(this).closest("tr");
      let data = me.accountsTable.row(tr[0]).data();

      if (data.accid && data.accid != "" && data.accid.length == 21) {
        me.globals.showConfirmAlert(
          "Change account?",
          "Are you sure you want to change accounts?",
          "OK",
          "CANCEL",
          () => {
            me.switchAccount(data.accid);

            $("#show-manage-accounts").modal("hide");
          }
        );
      }
    });

    //Audit Click
    me.accountsTable.on("click", ".audit-account", function () {
      let tr = $(this).closest("tr");
      let data = me.accountsTable.row(tr[0]).data();
      if (data.accid && data.accid != "" && data.accid.length == 21) {
        me.auditAccid = data.accid;

        me.auditTable.ajax.reload();
        $("#show-accounts-audit").modal("show");
      }

      //TODO: show audit trail
    });

    //Suspend click
    me.accountsTable.on("click", ".suspend-account", function () {
      let tr = $(this).closest("tr");
      let data = me.accountsTable.row(tr[0]).data();

      if (data.active) {
        //Suspend
        me.globals.accountToggleActive(
          data.accid,
          false,
          (r: any) => {
            if (r.status) {
              me.accountsTable.ajax.reload();
            } else {
              me.globals.showWarningAlert(
                "Error",
                "Could not suspend account."
              );
            }
          },
          () => {},
          true
        );
      } else {
        //Resume
        me.globals.accountToggleActive(
          data.accid,
          true,
          (r: any) => {
            if (r.status) {
              me.accountsTable.ajax.reload();
            } else {
              me.globals.showWarningAlert(
                "Error",
                "Could not suspend account."
              );
            }
          },
          () => {},
          true
        );
      }
      //TODO: suspend/resume account
    });
  }

  createAuditTable() {
    let me = this;

    //Create the people data-table
    this.auditTable = $("#audit-table").DataTable({
      paging: true,
      ordering: true,
      info: true,
      serverSide: true,
      processing: true,
      responsive: true,
      pagingType: "numbers",
      pageLength: 10,
      lengthChange: false,
      order: [[0, "desc"]],
      language: {
        searchPlaceholder: "Search",
      },
      initComplete: function () {},
      columns: [
        {
          data: "datetime",
          orderable: true,
          searchable: false,
          className: "column-bold",
        },
        {
          data: "username",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "name",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "action",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "snr",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "description",
          orderable: false,
          searchable: true,
          className: "text-center",
        },
        {
          data: "tools",
          orderable: false,
          searchable: false,
          className: "col-tools text-center column-nowrap",
        },
      ],
      ajax: {
        url: me.globals.apiRootNew + "/audit/pageByAccid",
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        beforeSend: function (request) {
          //Setup the header
          request.setRequestHeader("api-key", me.globals.apiKey);
        },

        data: function (data) {
          //Format the data object
          let o = {
            token: me.globals.token,
            accid: me.auditAccid,
            seq: data.draw,
            from: data.start,
            length: data.length,
            search: data.search.value,
            order: data.columns[data.order[0].column].data,
            direction: data.order[0].dir,
          };

          //To string
          return JSON.stringify(o);
        },

        dataFilter: function (data) {
          //Make an object
          let response = jQuery.parseJSON(data);
          me.globals.handleSuccess(response);
          //Session expired
          if (!response.data) {
            return JSON.stringify({
              recordsTotal: 0,
              recordsFiltered: 0,
              draw: 0,
              data: [],
            });
          }

          //Add the tools field
          for (var i = 0; i < response.data.length; i++) {
            //Extract some data
            let accid = response.data[i].accid;
            let tools = me.buildAuditToolsField(accid);
            let snr = response.data[i].snr ? response.data[i].snr : "";

            //Reformat
            response.data[i].DT_RowId = accid;
            response.data[i].tools = tools.html;

            // // response.data[i].tools = "";
            let isoDate = new Date(response.data[i].datetime);

            response.data[i].datetime = moment(isoDate).format(
              me.globals.dateTimeFormat
            );
            response.data[i].snr = snr;

            //format data fields
            if (response.data[i].field && response.data[i].field == "orgunit") {
              response.data[i].field = "usergroup";
            }
            if (response.data[i].field && response.data[i].field == "class") {
              response.data[i].field = "devicegroup";
            }

            if (
              response.data[i].description &&
              response.data[i].description.includes("device/remove")
            ) {
              response.data[i].description = "device/delete";
            }
            if (
              response.data[i].description &&
              response.data[i].description.includes("person/remove")
            ) {
              response.data[i].description = "person/delete";
            }
            if (
              response.data[i].description &&
              response.data[i].description.includes("device/add")
            ) {
              response.data[i].description = "device/add";
            }
            if (
              response.data[i].description &&
              response.data[i].description.includes("device/set")
            ) {
              response.data[i].description = "device/edit";
            }
            if (
              response.data[i].description &&
              response.data[i].description.charAt(0) == "/"
            ) {
              let newDesc = response.data[i].description;
              response.data[i].description = newDesc.substring(1);
            }
          }

          //Return an empty record
          return JSON.stringify({
            recordsTotal: response.total,
            recordsFiltered: response.filtered,
            draw: response.seq,
            data: response.data,
          });
        },
      },
    });

    me.auditTable.on("click", ".audit-details", function () {
      let tr = $(this).closest("tr");
      let data = me.auditTable.row(tr[0]).data();

      //show details
      //Keep
      me.jsonData = JSON.parse(data.details);
      me.jsonTitle = data.accid;

      $("#modal-detail-data").modal("show");

      //Apply css
      $(".ngx-json-viewer").css("overflow", "auto");
    });
  }

  editAccount(data) {}

  buildAuditToolsField(accid) {
    //Format the HTML
    let auditDetails =
      '<a style="cursor: pointer;" title="View audit trail" class="audit-details"><i class="saf saf-menu saf-action" aria-hidden="true"></i></a>';
    return {
      id: accid,
      html: auditDetails + "&nbsp;&nbsp;",
    };
  }

  buildAccountToolsField(accid, active: boolean = true) {
    //Format the HTML
    let auditHtml =
      '<a style="cursor: pointer;" title="View audit trail" class="audit-account"><i class="saf saf-menu saf-action" aria-hidden="true"></i></a>';
    let gotoHtml = "";
    //Build suspend icon
    let susIcon = "";
    let susDesc = "";
    if (active) {
      susIcon = "saf-close";
      susDesc = "Suspend account";

      //show goto
      gotoHtml =
        '<a style="cursor: pointer;" title="Go to account" class="goto-account"><i class="saf saf-goto saf-action" aria-hidden="true"></i></a>';
    } else {
      susIcon = "saf-tick";
      susDesc = "Resume account";
    }
    let suspendHtml = `<a style="cursor: pointer;" title="${susDesc}" class="suspend-account"><i class="saf ${susIcon} saf-action" aria-hidden="true"></i></a>`;

    return {
      id: accid,
      html:
        gotoHtml + "&nbsp;&nbsp;" + auditHtml + "&nbsp;&nbsp;" + suspendHtml,
    };
  }

  updateAccount() {
    let name = $("#info-company").val();

    this.globals.accountUpdateName(name, (r: any) => {
      this.globals.showSuccessAlert("Success", "Account successfully updated");
    });
  }

  //-------------------- OTHER--------------------//

  support() {
    this.globals.showWarningAlert("Support", "Coming soon.");
  }

  onResized(event) {
    this.globals.globalEvents.emit("resize");
  }

  adminPage() {
    //Close the Account manage modal if open
    $("#show-manage-accounts").modal("hide");

    if (this.adminHeader == "Open Admin") {
      this.adminHeader = "Close Admin";
      this.router.navigate(["admin"]);
    } else if (this.adminHeader == "Close Admin") {
      this.adminHeader = "Open Admin";
      this.router.navigate(["analytics"]);
    }
  }

  signOut() {
    this.globals.signout(false);
  }

  changePassword() {
    //Show password modal
    $("#change-pass-modal").modal("show");
  }

  changePass() {
    //Check if passwords match
    if (this.pass1 == this.pass2 && this.globals.validatePwd(this.pass1)) {
      this.globals.peopleUpdatePassword(
        this.pass1,
        (r: any) => {
          //Success
          this.globals.showSuccessAlert(
            "SUCCESS",
            `The password for ${this.globals.username} has been successfully reset.`
          );
        },
        () => {
          //Failure
          this.globals.showWarningAlert(
            "Update Password",
            "The password update failed."
          );
          this.pass1 = "";
          this.pass2 = "";
        }
      );
    } else {
      if (this.pass1 !== this.pass2) {
        this.globals.showWarningAlert(
          "Update Password",
          "The passwords doesn't match."
        );
        this.pass1 = "";
        this.pass2 = "";
      } else {
        this.globals.showWarningAlert(
          "Update Password",
          "The password doesn't contain all the prescribed characters."
        );
        this.pass1 = "";
        this.pass2 = "";
      }
    }
  }

  supportShowFAQs() {
    this.router.navigate(["faq"]);
  }

  routeToDash() {
    this.adminHeader = "Open Admin";
    this.router.navigate(["analytics"]);
  }

  accountInfo() {
    //Get account details
    //Show modal
    $("#show-account-info").modal("show");
  }

  changeAccount() {
    $("#show-account-change").modal("show");
  }

  doChangeAccount() {
    //Get accid
    let accid = $("#info-new-account-id").val();

    //Check that accid is valid
    if (accid && accid != "" && accid.length == 21) {
      this.switchAccount(accid);
    } else if (accid.length == 0) {
      this.globals.showWarningAlert("Error", "Account ID may not be empty.");
    } else {
      this.globals.showWarningAlert("Error", "Account ID format not valid.");
    }
  }

  popoutFrame() {
    let url = this.globals.buildSettings.iframeLinks[0];

    url = url.replace(/\$ctoken/g, `ctoken=${this.globals.token}`);
    url = url.replace(/\$itoken/g, `itoken=${this.globals.iotToken}`);
    url = url.replace(/\$personid/g, `personid=${this.globals.personid}`);
    url = url.replace(/\$accid/g, `accid=${this.globals.entityAccid}`);
    url = url.replace(/\$username/g, `username=${this.globals.username}`);
    url = url.replace(/\$nickname/g, `nickname=${this.globals.nickname}`);
    url = url.replace(/\$email/g, `email=${this.globals.email}`);
    url = url.replace(
      /\$flavour/g,
      `flavour=${this.globals.buildSettings.appFlavour}`
    );
    url = url.replace(/\$role/g, `role=${this.globals.userAccess.role}`);
    url = url.replace(
      /\$ftp/g,
      `flavourtype=${this.globals.buildSettings.flavourType}`
    );
    url = url.replace(/\$entity/g, `entity=${this.globals.entityName}`);
    window.open(url);
  }

  switchAccount(accid) {
    //Do account change
    //Must change the account
    this.globals.changeAccount(
      accid,
      () => {
        //Refresh info
        //Login to the IoT also
        this.globals.containerLogin(() => {
          this.globals.accountInfo(() => {
            //Success
            this.globals.currentView = "login";
            this.globals.currentView = "dashboard";
            this.router.navigate([this.globals.currentPage]);

            //Redraw all
            StatsComponent.instance.getDeviceData();
            StatsComponent.redraw();
            AnalyticsComponent.redraw();

            this.globals.showSuccessAlert(
              "Success",
              "Successfully changed accounts."
            );

            let iframe = document.getElementById(
              "centerIframe"
            ) as HTMLIFrameElement;

            const element: HTMLIFrameElement = document.getElementById(
              "centerIframe"
            ) as HTMLIFrameElement;
            const iframeElem = element.contentWindow;
            if (iframeElem !== null) {
              element.src = this.globals.getUrl(
                this.globals.buildSettings.iframeLinks[0]
              );
            }
            //Redraw orgunitslist
            this.globals.orgunitList(
              (r: any) => {
                //Success
                this.orgunitsList = r.data;
              },
              () => {
                //Failure
              }
            );

            //TODO: refresh all views
          });
        });
      },
      () => {
        //Failure
      }
    );
  }

  copyAccId() {
    //Get the element
    var copyText: any = document.getElementById("info-accid");
    copyText.disabled = false;

    //Select the text field
    copyText.select();
    copyText.setSelectionRange(0, 99999);

    //Copy the text inside the text field
    document.execCommand("copy");

    //Notify
    copyText.disabled = true;
    this.copied = true;

    // Start the timer
    let timerSession = setTimeout(() => {
      this.copied = false;
    }, 5000);

    //Deselect
    let t = copyText.value;
    copyText.value = "";
    copyText.value = t;
  }

  showFlavourMenu() {
    this.showFlavourSelector = !this.showFlavourSelector;
  }

  selectFlavour(flavour) {
    let link = this.globals.getUrl(flavour.link);

    // window.open(link);
    window.location = link;
  }

  onChangeAllowUser() {
    let state = this.allowUsers ? "ANONYMOUS_ACTIVE" : "ANONYMOUS_INACTIVE";
    this.globals.accountSetDefaultAgentState(state);
    //Update account
  }

  searchDeviceAsRoot() {
    //Show modal
    $("#modal-search-device").modal("show");
  }

  openTransferWizard() {
    $("#modal-transfer-decommission-device-select").modal("show");
  }

  selectTransferOption(option: "decommission" | "transfer") {
    this.decommissionType = option;

    $("#modal-transfer-device").modal("show");
  }

  searchDevAsRoot() {
    let snr = this.searchSnr;

    //Get info
    this.globals.devRootSearch(
      snr,
      (r: any) => {
        let device = r.device;
        let account = r.account;

        let mess = `
                     
                        
                        
                       
                        <b>Name</b>: ${device.name}<br>
                        <b>Time Zone</b>: ${device.timezone}<br>`;

        let mess2 = `<table class="tg">
           
            <tbody>
            <tr>
                <td align="left" class="tg-0pky"><b>ACCOUNT</b></td>
                <td align="left" class="tg-0pky"></td>
              </tr>
              <tr>
                <td align="left" class="tg-0pky"><b>Name</b>:</td>
                <td align="left" class="tg-0pky">${account.name}</td>
              </tr>
              <tr>
              <td align="left" class="tg-0pky"><b>Id</b>:</td>
              <td align="left" class="tg-0pky">${account.accid}</td>
            </tr>
            <tr>
            <td align="left" class="tg-0pky" align="left"><b>Email</b>:</td>
            <td align="left" class="tg-0pky" align="left">${account.email}</td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky" align="left"></td>
            <td align="left" class="tg-0pky"></td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky"> </td>
            <td align="left" class="tg-0pky"> </td>
          </tr>

          <tr>
            <td align="left" class="tg-0pky"><b>DEVICE</b>:</td>
            <td align="left" class="tg-0pky"></td>
          </tr>
          

          <tr>
          <td align="left" class="tg-0pky"><b>Created</b>:</td>
          <td align="left" class="tg-0pky">${device.created}</td>
        </tr>
        <tr>
            <td align="left" class="tg-0pky"><b>Last Comms</b>:</td>
            <td align="left" class="tg-0pky">${device.lastcomms}</td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky"><b>Model</b>:</td>
            <td align="left" class="tg-0pky">${device.model}</td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky"><b>SNR</b>:</td>
            <td align="left" class="tg-0pky">${device.snr}</td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky"><b>Name</b>:</td>
            <td align="left" class="tg-0pky">${device.name}</td>
          </tr>
          <tr>
            <td align="left" class="tg-0pky"><b>Timezone</b>:</td>
            <td align="left" class="tg-0pky">${device.timezone}</td>
          </tr>

              
            </tbody>
            </table>`;
        this.globals.showSuccessAlert("Device Found", mess2);
        // Show sweetswal with info
      },
      () => {}
    );
  }

  keepDeviceDisabled() {
    let disabled = false;

    if (this.transferDevice.keepAccount) {
      return true;
    }

    return disabled;
  }

  keepAccountDisabled() {
    let disabled = false;

    if (this.transferDevice.keepDevice) {
      return true;
    }

    return disabled;
  }

  doTransferDevice() {
    //Get old snr and accountNr

    let oldAccNr = this.globals.entityAccid;
    let oldSnr = this.transferDevice.oldSnr;

    let newSnr = this.transferDevice.newSnr
      ? this.transferDevice.newSnr
      : this.transferDevice.oldSnr;
    let newAccountNr = this.transferDevice.toAccount
      ? this.transferDevice.toAccount
      : this.globals.entityAccid;

    if (this.transferDevice.keepDevice) {
      newSnr = this.transferDevice.oldSnr;
    }
    if (this.transferDevice.keepAccount) {
      newAccountNr = this.globals.entityAccid;
    }

    //Do call
    this.globals.deviceTransfer(
      oldSnr,
      newSnr,
      newAccountNr,
      oldAccNr,
      (result: any) => {
        this.transferDevice.oldSnr = "";
        this.transferDevice.newSnr = "";
        this.transferDevice.toAccount = "";
        this.transferDevice.keepAccount = false;
        this.transferDevice.keepDevice = false;
      }
    );
  }

  doDecommission() {
    let snr = this.transferDevice.oldSnr;

    if (snr && snr != "" && snr.length > 3) {
    }
  }

  enableTransfer() {
    let o = this.transferDevice;
    if (this.transferDevice.keepDevice) {
      return o.toAccount && o.toAccount != "" && o.oldSnr && o.oldSnr != "";
    } else if (this.transferDevice.keepAccount) {
      return o.oldSnr && o.oldSnr != "" && o.newSnr && o.newSnr != "";
    } else {
      return (
        o.toAccount &&
        o.toAccount != "" &&
        o.oldSnr &&
        o.oldSnr != "" &&
        o.newSnr &&
        o.newSnr != ""
      );
    }
  }
}
